import { useEffect, useRef, useCallback } from 'react';
import { LatLng } from "./common/Geography";

export enum WorkerRequestType {
    Init,
    Start,
    Stop
}

export enum WorkerResponseType {
    PassFound,
    Progress,
    Error,
}

export interface WorkerRequestStart {
    type:        WorkerRequestType.Start;
    target:      LatLng;
    startDate:   string;
    endDate:     string;
    maxOffNadir: number; //angle in deg
    minSunElev:  number; //angle in deg
}

export type WorkerRequest = WorkerRequestStart;

export interface WorkerResponsePass {
    type:    WorkerResponseType.PassFound;
    payload: OrbitalPassStep[];
}

export interface OrbitalPassStep {
    satelliteName:       string;    
    date:                number; //epochMilli
    tick:                number; //epochMilli
    epoch:               number; //epochMilli
    altitude:            number; //km
    slantRange:          number; //km
    groundRange:         number; //km
    elevation:           number; //angle
    offNadir:            number; //angle
    sunElev:             number; //angle    
    cloudCover:          number; //0-100
}

export interface OrbitalPass {
    satelliteName:       string;
    date:                number; //epochMilli
    earlyTime:           number; //epochMilli
    midTime:             number; //epochMilli
    lastTime:            number; //epochMilli    
    samples:             number; 
    firstAlt:            number; //km
    apexAlt:             number; //km
    lastAlt:             number; //km
    sunElev:             number; //angle
    firstOffNadir:       number; //angle 
    apexOffNadir:        number; //angle
    lastOffNadir:        number; //angle    
    cloudCover:          number; //0-100
}

export interface WorkerResponseError {
    type:  WorkerResponseType.Error;
    error: string;
}

export interface WorkerResponseProgress {
    type:  WorkerResponseType.Progress;
    status: string; 
    value:  number;
}

export type WorkerResponse = WorkerResponsePass | WorkerResponseProgress | WorkerResponseError;
